import { render, staticRenderFns } from "./EventBenefit.vue?vue&type=template&id=72d2d327&scoped=true&"
import script from "./EventBenefit.vue?vue&type=script&lang=js&"
export * from "./EventBenefit.vue?vue&type=script&lang=js&"
import style0 from "./EventBenefit.vue?vue&type=style&index=0&id=72d2d327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2d327",
  null
  
)

export default component.exports